import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SubNav from 'components/SubNav';
import Spinner from 'components/Spinner';
import ConfirmSwitchAttToSprintForm from 'components/ConfirmSwitchAttToSprintForm';

export default class ConfirmSwitchToSprint extends Component {
  constructor(props) {
    super(props);

    this.confirmSwitchAttToSprint = this.confirmSwitchAttToSprint.bind(this);

    this.state = {
      error: null,
      successMsg: '',
      sprintSub: null,
      showLoader: false,
    };
  }

  get redirectLink() {
    const { sub } = this.props;
    return `/att/subscriptions/${sub.id}/view`;
  }

  get attRedirectLink() {
    const { sprintSub } = this.state;
    return `/subscriptions/${sprintSub.id}/view`;
  }

  get isSuccess() {
    const { successMsg } = this.state;
    return successMsg === 'Success';
  }

  get initialValues() {
    const {
      sub: {
        first_name,
        last_name,
        agent_id,
        csa,
        intl_charge_threshold,
        profile_image,
      },
    } = this.props;

    return {
      first_name,
      last_name,
      agent_id,
      csa,
      intl_charge_threshold,
      profile_image,
    };
  }

  async confirmSwitchAttToSprint(payload) {
    const {
      confirmSwitchAttToSprint,
      sub: { id },
    } = this.props;

    this.setState({ showLoader: true });
    const response = await confirmSwitchAttToSprint(id, payload);

    if (response.status === 200) {
      this.setState({
        error: null,
        successMsg: 'Success',
        sprintSub: response.data,
      });
    } else {
      this.setState({ error: response.response.data, successMsg: '' });
    }
    this.setState({ showLoader: false });
  }

  render() {
    const { sub } = this.props;

    if (!sub) {
      return <div>Loading...</div>;
    }

    if (!sub.plan) {
      return (
        <React.Fragment>
          <SubNav />
          <Link to={this.redirectLink}>Back to subscription page</Link>
        </React.Fragment>
      );
    }

    const { error, successMsg, showLoader } = this.state;

    return (
      <div style={{ position: 'relative' }}>
        <h1>Confirm switch from AT&amp;T to Sprint</h1>
        <SubNav />
        <br />
        <ConfirmSwitchAttToSprintForm
          errorMsg={error}
          successMsg={successMsg}
          initialValues={this.initialValues}
          onSubmit={this.confirmSwitchAttToSprint}
        />
        <br />
        {this.isSuccess && (
          <p>
            <Link to={this.attRedirectLink}>
              Go to Sprint subscription page
            </Link>
          </p>
        )}
        <Link to={this.redirectLink}>Back to subscription page</Link>
        <Spinner showLoader={showLoader} />
      </div>
    );
  }
}
